function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import React, { PureComponent } from 'react';
import Message from '../message';
import Icon from '../icon';
import { addKeyframe, removeKeyframe, existKeyframe } from '../utils/keyframes';
var NOTICEBAR_KEYFRAME_NAME = 'za-notice-bar-scrolling';

var NoticeBar =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(NoticeBar, _PureComponent);

  function NoticeBar() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, NoticeBar);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(NoticeBar)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.wrapper = null;
    _this.content = null;
    _this.state = {
      animationDuration: 0
    };
    return _this;
  }

  _createClass(NoticeBar, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.updateScrolling();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.updateScrolling();
    }
  }, {
    key: "updateScrolling",
    value: function updateScrolling() {
      var _this$props = this.props,
          speed = _this$props.speed,
          delay = _this$props.delay;
      var wrapWidth = this.wrapper.getBoundingClientRect().width;
      var offsetWidth = this.content.getBoundingClientRect().width;

      if (offsetWidth > wrapWidth) {
        // 完整的执行时间 = 前后停留时间 + 移动时间
        var animationDuration = Math.round(delay * 2 + offsetWidth / speed * 1000); // 计算停留时间占总时间的百分比

        var delayPercent = Math.round(delay * 100 / animationDuration); // 删除之前的 keyframe 定义

        if (existKeyframe(NOTICEBAR_KEYFRAME_NAME)) {
          removeKeyframe(NOTICEBAR_KEYFRAME_NAME);
        } // 增加重新计算后的 keyframe


        addKeyframe(NOTICEBAR_KEYFRAME_NAME, "\n        0%, ".concat(delayPercent, "% {\n          -webkit-transform: translate3d(0, 0, 0);\n          transform: translate3d(0, 0, 0);\n        }\n      \n        ").concat(100 - delayPercent, "%, 100% {\n          -webkit-transform: translate3d(").concat(-(offsetWidth - wrapWidth), "px, 0, 0);\n          transform: translate3d(").concat(-(offsetWidth - wrapWidth), "px, 0, 0);\n        }\n      "));
        this.setState({
          animationDuration: animationDuration
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          prefixCls = _this$props2.prefixCls,
          children = _this$props2.children,
          others = _objectWithoutProperties(_this$props2, ["prefixCls", "children"]);

      var animationDuration = this.state.animationDuration;
      return React.createElement(Message, _extends({}, others, {
        size: "lg"
      }), React.createElement("div", {
        className: prefixCls,
        ref: function ref(ele) {
          _this2.wrapper = ele;
        }
      }, React.createElement("div", {
        className: "".concat(prefixCls, "__body"),
        ref: function ref(ele) {
          _this2.content = ele;
        },
        style: animationDuration > 0 ? {
          WebkitAnimation: "".concat(NOTICEBAR_KEYFRAME_NAME, " ").concat(animationDuration, "ms linear infinite"),
          animation: "".concat(NOTICEBAR_KEYFRAME_NAME, " ").concat(animationDuration, "ms linear infinite")
        } : undefined
      }, children)));
    }
  }]);

  return NoticeBar;
}(PureComponent);

NoticeBar.displayName = 'NoticeBar';
NoticeBar.defaultProps = {
  prefixCls: 'za-notice-bar',
  theme: 'warning',
  icon: React.createElement(Icon, {
    type: "broadcast"
  }),
  hasArrow: false,
  closable: false,
  speed: 50,
  delay: 2000
};
export { NoticeBar as default };